<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="''"
  (afterClose)="handleClose()"
>
  <div class="icon">
    <qai-icon [kind]="'upload'" [size]="'24px'"></qai-icon>
  </div>
  <div class="title">{{ 'simulationBuilder.PUBLISH_SIMULATION_HEADING' | transloco }}</div>
  <div class="content">
    {{ 'simulationBuilder.PUBLISH_SIMULATION_DESCRIPTION' | transloco }}
  </div>

  <div class="modal-actions">
    <button qai-button kind="secondary" [size]="'medium'" (click)="hideModal()">
      {{ 'simulationBuilder.PUBLISH_CONTINUE_EDITING' | transloco }}
    </button>
    <button
      qai-button
      kind="primary"
      [size]="'medium'"
      [disabled]="networkRequestInProgress"
      (click)="handleConfirm()"
    >
      {{ 'simulationBuilder.PUBLISH_BUTTON' | transloco }}
    </button>
  </div>
</dialog>
